import React from 'react'
import SubLink from '../../Route/SubLink';
import {GeneralManagerData} from '../../Route/SubLinkJSON';
export const Generalmanage=()=> {
  return (
    <React.Fragment>
       <SubLink sublinks={GeneralManagerData} />
      </React.Fragment>
  )
}